import React from 'react'
import PropTypes from 'prop-types'
import {
  translatable,
  Refinement,
  RefinementValue,
} from 'react-instantsearch-core'
import { createClassNames } from '../../../helpers'
import Tag from '@bit/atd.web.cta.tag'
import Grid from '@bit/atd.web.grid'
import { makeStyles } from '@material-ui/core/styles'
import { RefineListItem } from '../../../config/facets'

const cx = createClassNames('CurrentRefinements')

type PropTypes = {
  items: Refinement[]
  canRefine: boolean
  refine: (item: RefinementValue) => void
  translate: (key: string, ...params: any[]) => string
  className?: string
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    margin: '0px 16px 8px 0px',
  },
  closeBtn: {
    padding: '0px 6px',
    fontSize: '16px',
  },
})

export const CurrentRefinements = ({ items, refine, translate }: PropTypes) => {
  const classes = useStyles()
  return items.map((item: Refinement) =>
    item?.items?.map((item: RefineListItem) => {
      const doRefine = () => {
        item?.refineValues
          ? item.refineValues.forEach((value: RefinementValue) => refine(value))
          : refine(item.value)
      }
      return (
        <Grid item className={classes.root} key={item.label}>
          <Tag onClick={doRefine}>
            <span className={cx('category')}>
              <span>{item.label}</span>
              <div className={classes.closeBtn}>
                {translate('clearFilter', item)}
              </div>
            </span>
          </Tag>
        </Grid>
      )
    }),
  )
}

CurrentRefinements.defaultProps = {
  className: '',
}

export default translatable({
  clearFilter: '✕',
  // @ts-ignore
})(CurrentRefinements)
